var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChooseSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#B89054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.926 5.37048C14.2129 5.67174 14.2129 6.16018 13.926 6.46144L8.04844 12.6329C7.76153 12.9341 7.29635 12.9341 7.00943 12.6329L4.07066 9.54716C3.78374 9.24589 3.78374 8.75745 4.07066 8.45619C4.35757 8.15493 4.82275 8.15493 5.10967 8.45619L7.52894 10.9964L12.887 5.37048C13.1739 5.06922 13.6391 5.06922 13.926 5.37048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseSignIn);
export default __webpack_public_path__ + "static/media/choose_sign_in.49a303fb906d24d88b0c6adc80848c31.svg";
export { ForwardRef as ReactComponent };